import React, { memo, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNotification, useUserPermission } from "@hooks/index";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import { SvgCakeIcon, SvgEditIcon } from "@routes/IconeSvg";
import FloatButton from "@components/buttons/FloatButton";
import { Avatar } from "@components/tailwindComponents";
import DeleteItemButton from "@components/tailwindComponents/DeleteItemButton";
import BlackTooltip from "@components/tooltip/BlackTooltip";
import {
  ANNIVERSARY_BIRTH_TYPE,
  ANNIVERSARY_HIRING_TYPE
} from "@helpers/_constants";
// import { getDateToRender } from "@helpers/_functions";
import { Anniversary } from "@services/anniversary.service";
import CModalAddNoteAnniversary from "./ModalAddNote";
import CModalDeleteNote from "./ModalDeleteNote";
import { useAccessFolderEnterprise } from "@hooks/employeFolder";
import moment from "moment-timezone";

const useStylesBootstrap = makeStyles(() => ({
  arrow: {
    color: "#3F3F51"
  },
  tooltip: {
    maxWidth: "358px",
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    fontSize: "13px",
    padding: "12px 17px"
  }
}));

function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();
  return <Tooltip arrow classes={classes} {...props} />;
}

const ItemListAnniversary = ({ employe, isHiringSelected }) => {
  const [showModalAddNote, setModalAddNoteStatus] = useState(false);
  const [showModalDeleteNote, setModalDeleteNoteStatus] = useState(false);
  const { goToEmployerFolder } = useAccessFolderEnterprise();
  const { canVisibleYearOfBirth } = useUserPermission();
  const { showSuccess, showError } = useNotification();
  const { t: translate, i18n } = useTranslation("pages.employés.anniversary");

  const toggleModalAddNote = useCallback(
    () => setModalAddNoteStatus((_showModalAddNote) => !_showModalAddNote),
    []
  );

  const toggleModalDeleteNote = useCallback(
    () =>
      setModalDeleteNoteStatus((_showModalDeleteNote) => !_showModalDeleteNote),
    []
  );

  const deleteNoteClick = useCallback(() => {
    Anniversary.deleteNote(employe.anniversaryNotes._id)
      .then(() => {
        showSuccess("delete_action_success", { object: "note" });
        setModalDeleteNoteStatus(false);
      })
      .catch((err) => {
        showError("error_occured", {
          mode: "action_mode_delete",
          object: "note"
        });
        console.error(err);
      });
  }, [employe?.anniversaryNotes?._id]);

  const _goToEmployerFolder = () => {
    goToEmployerFolder({ employerId: employe?._id, employerSalaryId: employe?.emploiSalaryId })
  }

  const anniversaryDate = useMemo(() => {
    const date = moment(employe?.anniversaryDate, "DD/MM/YYYY").locale(
      i18n.language
    );

    if (!date.isValid()) return "";
    return !canVisibleYearOfBirth && !isHiringSelected
      ? date.format("D MMMM")
      : date.format("LL");
  }, [
    isHiringSelected,
    employe?.anniversaryDate,
    canVisibleYearOfBirth,
    i18n.language
  ]);
  const ages = useMemo(() => isHiringSelected ? (() => {
    const years = Math.floor(employe?.age);
    const months = Math.round((employe?.age % 1) * 12);
    const _years = years > 0 ? `${years} ${translate("années")}` : ""
    return `${_years} ${months} ${translate("mois")}`;
  })() : canVisibleYearOfBirth ? `${Math.floor(employe?.age)} ${translate("ans")}` : "-", [isHiringSelected, employe?.age, canVisibleYearOfBirth, translate])
  return (
    <>
      <tr className="arh-border arh-border-solid arh-border-borderTable arh-border-t-0 arh-border-x-0 hover:arh-bg-greyColor">
        <td className="arh-py-4 arh-px-4">
          <div className="arh-p-0 arh-flex arh-items-center arh-cursor-pointer" onClick={_goToEmployerFolder}>
            <Avatar
              src={employe?.images?.location}
              name={employe?.fullname}
              textStyle="desktop-middle:arh-w-24 arh-max-w-[12rem]  arh-truncate arh-font-poppins arh-font-medium arh-text-xs !arh-text-darkGreyColor"
            />
          </div>
        </td>

        <td style={{ textAlign: "center" }} className="arh-px-4">
          <div className="arh-p-0 arh-cursor-pointer" onClick={_goToEmployerFolder}>
            <span className="arh-flex arh-items-center">
              {SvgCakeIcon()}
              <span className="arh-font-poppins arh-font-medium arh-text-xs !arh-text-darkGreyColor arh-ml-7">
                {anniversaryDate}
              </span>
            </span>
          </div>
        </td>

        <td style={{ textAlign: "center" }} className="arh-px-4">
          <div

            className="arh-p-0 arh-flex arh-items-center justify-content-center arh-cursor-pointer" onClick={_goToEmployerFolder}
          >
            <span className="arh-font-poppins arh-font-medium arh-text-xs  !arh-text-darkGreyColor ">
              {ages}
            </span>
          </div>
        </td>

        <td className="arh-px-4">
          <div
            className="arh-p-0 arh-font-poppins arh-font-medium arh-text-xs !arh-text-darkGreyColor arh-px-4 arh-cursor-pointer" onClick={_goToEmployerFolder}
          >
            {!employe?.groupsName ? (
              <div className="arh-w-full">{translate("Aucun")}</div>
            ) : (
              <BlackTooltip title={employe?.groupsName} placement="top-start">
                <div className="arh-w-full arh-truncate">
                  {employe?.groupsName}
                </div>
              </BlackTooltip>
            )}
          </div>
        </td>

        <td className=" arh-px-4 ">
          <div className="arh-p-0 arh-flex arh-items-center arh-font-poppins arh-font-medium arh-text-xs  !arh-text-darkGreyColor arh-pr-[2rem] arh-cursor-pointer ">
            {employe?.anniversaryNotes?.content ? (
              <BootstrapTooltip
                title={
                  <p
                    className="arh-m-0 arh-w-full"
                    style={{
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 5,
                      fontSize: "12px"
                    }}
                  >
                    {employe?.anniversaryNotes?.content}
                  </p>
                }
                placement="top-end"
              >
                <span className="info_anniversaire arh-truncate">
                  {employe?.anniversaryNotes?.content}
                </span>
              </BootstrapTooltip>
            ) : (
              <div className="add_note regular">{`${translate(
                "Ajouter une note"
              )}...`}</div>
            )}
          </div>
        </td>

        <td style={{ textAlign: "center" }} className="arh-px-4">
          {/* {
              this.props.employe?.anniversaryNotes ? */}
          {/* : */}
          <div className="arh-flex arh-space-x-4 desktop-middle:arh-space-x-2">
            <FloatButton
              size="arh-w-7 arh-h-7"
              onClick={toggleModalAddNote}
              color="arh-bg-transparent hover:arh-bg-gray-200 active:arh-bg-greyActive"
            >
              <SvgEditIcon />
            </FloatButton>
            {employe?.anniversaryNotes && (
              <DeleteItemButton onClick={toggleModalDeleteNote} />
            )}
          </div>
          {/* } */}
        </td>
      </tr>
      {/* Modals */}
      <CModalAddNoteAnniversary
        noteValue={employe?.anniversaryNotes?.content}
        onClickClose={toggleModalAddNote}
        employe={employe}
        anniversaryDate={anniversaryDate}
        noteType={
          isHiringSelected ? ANNIVERSARY_HIRING_TYPE : ANNIVERSARY_BIRTH_TYPE
        }
        isOpen={showModalAddNote}
      />
      <CModalDeleteNote
        onClickClose={toggleModalDeleteNote}
        textDelete={translate(
          "Êtes-vous sûr de vouloir supprimer cette note ?"
        )}
        deleteNote={deleteNoteClick}
        isOpen={showModalDeleteNote}
      />
    </>
  );
};

export default memo(ItemListAnniversary);
